"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoomI18n = void 0;
var i18next_1 = __importDefault(require("i18next"));
var i18next_icu_1 = __importDefault(require("i18next-icu"));
var i18next_xhr_backend_1 = __importDefault(require("i18next-xhr-backend"));
var strip_json_comments_1 = __importDefault(require("strip-json-comments"));
var ChainedBackend_1 = __importDefault(require("./ChainedBackend"));
var Currency_1 = require("./utils/Currency");
var Currency_2 = require("./utils/Currency");
Object.defineProperty(exports, "Currency", { enumerable: true, get: function () { return Currency_2.Currency; } });
var DEFAULT_LANGUAGE = "en";
var DEFAULT_PSEUDOLANGUAGE = "pseudo";
var DEFAULT_NS = "translation";
var DEFAULT_CURRENCY = Currency_1.Currency.Code.USD;
var DEFAULT_TIMEZONE = undefined; // undefined defaults to OS timezone
var MAXIMUM_FRACTION_DIGITS = 4;
/**
 * Base LoomI18n class. This class wraps an underlying library that does the actual translation
 * with support to ICU Message Format. Must be initialized before using.
 */
var LoomI18n = /** @class */ (function () {
    function LoomI18n() {
        var _this = this;
        this.defaultCurrency = DEFAULT_CURRENCY;
        this.defaultTimezone = DEFAULT_TIMEZONE;
        this.realT = function (key, args) {
            return _this.i18n.t(key, args);
        };
        this.pseudoT = function (key, args) {
            var s = _this.i18n.t(key, args).toLowerCase();
            // see https://www.w3.org/International/articles/article-text-size for a discussion
            // for the pseudo text length:
            var len = Math.ceil(s.length * 1.3) - s.length;
            var r = "eé".repeat(len).slice(len);
            return "[[" + s + " " + r + "]]";
        };
        this.tFn = this.realT;
        /**
         * Returns the string value associated with the provided key/arguments.
         *
         * @param key
         * @param args
         */
        this.t = function (key, args) {
            try {
                return _this.tFn(key, args);
            }
            catch (error) {
                _this.missingKeyCallback && _this.missingKeyCallback(key);
                console.error("Schema mismatch for Message with key " + key + ":", error);
                return "[" + key + "]";
            }
        };
        this.isInitialized = false;
        this.i18n = i18next_1.default.createInstance();
        this.i18n.init();
    }
    /**
     * Initialize the instance. If no {@code initOptions} are provided, use sensible defaults.
     * @param initOptions The options to use when initializing the instance.
     * @returns Promise<void>
     */
    LoomI18n.prototype.init = function (initOptions) {
        if (initOptions === void 0) { initOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var defaultLanguage, bundledLanguages, i18nInitOptions;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (initOptions.defaultLanguage === DEFAULT_PSEUDOLANGUAGE) {
                            initOptions.defaultLanguage = DEFAULT_LANGUAGE;
                            this.tFn = this.pseudoT;
                        }
                        initOptions.defaultCurrency && (this.defaultCurrency = initOptions.defaultCurrency);
                        initOptions.defaultTimezone && (this.defaultTimezone = initOptions.defaultTimezone);
                        // Create the instance that we will actually initialize. This allow calling init multiple times (if
                        // user wants to re-initialize the instance), and allow us to initialize to a dummy instance in the
                        // constructor above
                        this.i18n = i18next_1.default.createInstance();
                        // Setup the ICU (International Components for Unicode) message format
                        // This is the module that support pluralization and formatting of numbers and dates.
                        this.icu = new i18next_icu_1.default({
                            formats: __assign(__assign({}, getDateTimeFormats(this.defaultTimezone)), getCurrencyFormats(this.defaultCurrency)),
                        });
                        this.bundledLocaleData = new Set();
                        if (initOptions.localesData) {
                            Object.keys(initOptions.localesData).forEach(function (locale) {
                                _this.icu.addLocaleData(initOptions.localesData[locale]);
                                _this.bundledLocaleData.add(locale);
                            });
                        }
                        defaultLanguage = initOptions.defaultLanguage || DEFAULT_LANGUAGE;
                        if (!!this.bundledLocaleData.has(defaultLanguage)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.loadLocaleData(defaultLanguage)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.i18n.use(this.icu);
                        bundledLanguages = Object.keys(initOptions.resources || {});
                        i18nInitOptions = {
                            lng: defaultLanguage,
                            fallbackLng: __spread(bundledLanguages, [DEFAULT_LANGUAGE]),
                            defaultNS: DEFAULT_NS,
                            debug: false,
                            lowerCaseLng: false,
                            resources: adaptResources(initOptions.resources),
                            saveMissing: true,
                            // Adding a no-op missing key handler as we use the even onMissingKey instead.
                            // If we don't set an handler here when saveMissing is true, then i18next will
                            // try to save the missing key to the backend
                            missingKeyHandler: function () { return undefined; },
                        };
                        // Initialization is different depending if we have remote resources or not, so we need to branch on this.
                        // The main difference is that when using remote file, we need to initialize without bundled resources first,
                        // Then add the bundles. When using w/o remote resource, we initialize with the bundles directly
                        if (initOptions.remoteResourcesPatterns) {
                            return [2 /*return*/, this.initWithBackend(initOptions, i18nInitOptions)
                                    .then(function () {
                                    _this.isInitialized = true;
                                    _this.initCallback && _this.initCallback(i18nInitOptions.lng);
                                })
                                    .catch(function (error) {
                                    _this.initCallback && _this.initCallback(i18nInitOptions.lng, error);
                                    throw error;
                                })];
                        }
                        else {
                            return [2 /*return*/, this.initWithBundle(initOptions, i18nInitOptions)
                                    .then(function () {
                                    _this.isInitialized = true;
                                    _this.initCallback && _this.initCallback(i18nInitOptions.lng);
                                })
                                    .catch(function (error) {
                                    _this.initCallback && _this.initCallback(i18nInitOptions.lng, error);
                                    throw error;
                                })];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Initialize the instance synchronously. Can only be used when not using remote resources feature.
     * If no {@code initOptions} are provided, use sensible defaults.
     * @param initOptions same as @see InitOptions, but without `remoteResourcesPatterns`
     */
    LoomI18n.prototype.initSync = function (initOptions) {
        if (initOptions === void 0) { initOptions = {}; }
        this.init(initOptions);
    };
    LoomI18n.prototype.initWithBackend = function (initOptions, i18nInitOptions) {
        return __awaiter(this, void 0, void 0, function () {
            var backendChain;
            var _this = this;
            return __generator(this, function (_a) {
                // Prevent remote loading of resources already bundled
                i18nInitOptions.partialBundledLanguages = true;
                backendChain = new ChainedBackend_1.default(initOptions.remoteResourcesPatterns.map(function (remoteResourcesPattern) {
                    return new i18next_xhr_backend_1.default(null, {
                        loadPath: remoteResourcesPattern,
                        parse: function (data) { return JSON.parse(strip_json_comments_1.default(data)); },
                    });
                }));
                this.i18n.use(backendChain);
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.i18n.init(i18nInitOptions, function (err) {
                            // Only propagate the error if we do not have resources for the default language
                            if (err && !initOptions.resources) {
                                reject(err);
                            }
                            resolve();
                        });
                    })];
            });
        });
    };
    LoomI18n.prototype.initWithBundle = function (initOptions, i18nInitOptions) {
        return __awaiter(this, void 0, void 0, function () {
            var res, rej, p;
            return __generator(this, function (_a) {
                // Setting this flag allow init to be synchronous, which is ok in this case since we do not have remote
                // resources to fetch.
                i18nInitOptions.initImmediate = false;
                p = new Promise(function (resolve, reject) {
                    res = resolve;
                    rej = reject;
                });
                this.i18n.init(i18nInitOptions, function (err) {
                    // Only propagate the error if we do not have resources for the default language
                    if (err && (!initOptions.resources || !i18nInitOptions.lng || !initOptions.resources[i18nInitOptions.lng])) {
                        rej(err);
                    }
                    res();
                });
                return [2 /*return*/, p];
            });
        });
    };
    LoomI18n.prototype.loadLocaleData = function (language) {
        var _this = this;
        var languageCode = language.split("-")[0];
        var localeDataPromise = Promise.resolve();
        // If we are running inside a browser, we need to dynamically load the locale-data to get proper
        // localization of plurals, dates and times.
        if (window && window.document && window.document.createElement) {
            localeDataPromise.then(function () {
                return new Promise(function (resolve) {
                    // Check if the language data was loaded on init
                    if (_this.bundledLocaleData.has(languageCode)) {
                        return resolve();
                    }
                    // Check if we already loaded the locale data
                    var reactIntlLocaleData = window.ReactIntlLocaleData;
                    if (reactIntlLocaleData && reactIntlLocaleData[languageCode]) {
                        return resolve();
                    }
                    // Check if we already added the script to the page
                    var id = "loomi18n-locale-data-" + language;
                    if (window.document.getElementById(id)) {
                        return resolve();
                    }
                    var localeDataScript = window.document.createElement("script");
                    localeDataScript.id = id;
                    localeDataScript.async = true;
                    localeDataScript.src = "https://locales.plugins.oci.oraclecloud.com/locale-data/" + languageCode + ".js";
                    localeDataScript.onload = function () {
                        // We need to re-read the object from window here, as it may not have existed previously
                        var reactIntlLocaleData = window.ReactIntlLocaleData;
                        if (reactIntlLocaleData && reactIntlLocaleData[languageCode]) {
                            _this.icu.addLocaleData(window.ReactIntlLocaleData[languageCode]);
                        }
                        else {
                            console.warn("Loaded locale-data script for languageCode " + languageCode + " did not provide corresponding locale-data");
                        }
                        return resolve();
                    };
                    localeDataScript.onerror = function (err) {
                        // We should not crash if we cannot load locale-data
                        console.warn("Error while loading locale-data script for languageCode " + languageCode + ":", err);
                        return resolve();
                    };
                    window.document.body.appendChild(localeDataScript);
                });
            });
        }
        return localeDataPromise;
    };
    /**
     * Change the language of the current instance.
     * @param language New language to use. Can be either language code (e.g. "en"), or locale code (e.g. "en-US"))
     * @returns Promise<void>
     */
    LoomI18n.prototype.changeLanguage = function (language) {
        return __awaiter(this, void 0, void 0, function () {
            var realLangauge, localeDataPromise, changeLanguagePromise;
            var _this = this;
            return __generator(this, function (_a) {
                realLangauge = language;
                if (realLangauge === DEFAULT_PSEUDOLANGUAGE) {
                    realLangauge = DEFAULT_LANGUAGE;
                    this.tFn = this.pseudoT;
                }
                else {
                    this.tFn = this.realT;
                }
                localeDataPromise = this.loadLocaleData(realLangauge);
                changeLanguagePromise = new Promise(function (resolve) {
                    _this.i18n.changeLanguage(realLangauge, function (err) {
                        // Only log and warning if language change failed, since it will fallback to default anyway
                        if (err) {
                            console.warn("changeLanguage", err);
                        }
                        resolve();
                    });
                });
                return [2 /*return*/, Promise.all([localeDataPromise, changeLanguagePromise])
                        .then(function () {
                        _this.changeLanguageCallback && _this.changeLanguageCallback(language);
                    })
                        .catch(function (_a) {
                        var _b = __read(_a, 2), localeDataError = _b[0], changeLanguageError = _b[1];
                        if (localeDataError) {
                            console.error("Could not load required locale-data", localeDataError);
                        }
                        if (changeLanguageError) {
                            console.error("Error while trying to change language", changeLanguageError);
                        }
                        _this.changeLanguageCallback &&
                            _this.changeLanguageCallback(realLangauge, localeDataError || changeLanguageError);
                        throw localeDataError || changeLanguageError;
                    })];
            });
        });
    };
    /**
     * Add a notification callback on change of language. Useful for applications that may need
     * to do work once the language is changed (e.g. forceUpdate of the root component in react).
     * Do not call this method before you called @method init
     * @param callback
     */
    LoomI18n.prototype.onLanguageChanged = function (callback) {
        this.changeLanguageCallback = callback;
    };
    /**
     * Add a notification callback on missing translation key. Useful for applications that may need to do
     * work once the translation key is missing in translation files.
     * Do not call this method before you called @method init
     * @param callback
     */
    LoomI18n.prototype.onMissingKey = function (callback) {
        this.missingKeyCallback = callback;
        this.i18n.on("missingKey", function (_, __, key) {
            callback(key);
        });
    };
    /**
     * If set before you call @method init this callback would be called.
     * @param callback
     */
    LoomI18n.prototype.onInit = function (callback) {
        this.initCallback = callback;
    };
    /**
     * Function to format currency.
     * @param value
     * @deprecated We will be removing "Code" and only have optional "Options" object where you can specify the currency
     * @param codeOrOptions Currency code to use, defaults to USD. Use getCurrencyCode to map string to Currency.Code enum
     * or Options object to set currencyCode(defaults to USD), displayFormat(Defaults to Symbol) and precision
     * @deprecated We will be removing "displayFormat" in the future. You can set this in the Options object
     * @param displayFormat Display as symbol or name. Eg. $5.00 or 5 US Dollars, Defaults to Symbol.
     * This is ignored if "Options" object is provided
     */
    LoomI18n.prototype.formatCurrency = function (value, codeOrOptions, displayFormat) {
        var code;
        var format;
        var precision;
        // In this case codeOrOptions will be a currency code
        if (codeOrOptions === undefined || typeof codeOrOptions === "string") {
            code = codeOrOptions;
            format = displayFormat;
        }
        // In this case codeOrOptions will be options object
        if (typeof codeOrOptions === "object") {
            code = codeOrOptions.currencyCode;
            format = codeOrOptions.displayFormat;
            precision = codeOrOptions.precision;
        }
        var options = {};
        options.style = "currency";
        options.currency = code || this.defaultCurrency;
        options.currencyDisplay = format;
        if (precision) {
            options.maximumFractionDigits = MAXIMUM_FRACTION_DIGITS;
        }
        return new Intl.NumberFormat(this.i18n.language, options).format(value);
    };
    return LoomI18n;
}());
exports.LoomI18n = LoomI18n;
function adaptResources(resources) {
    var i18nextResource = {};
    if (resources) {
        Object.keys(resources).forEach(function (key) {
            var _a;
            i18nextResource[key] = (_a = {},
                _a[DEFAULT_NS] = resources[key],
                _a);
        });
    }
    return i18nextResource;
}
function getCurrencyFormats(defaultCurrency) {
    // currency codes from https://www.currency-iso.org/dam/downloads/lists/list_one.xml
    var currencyCodes = Object.keys(Currency_1.Currency.Code);
    var currencySymbols = currencyCodes
        .map(function (v) {
        return { style: "currency", currency: v };
    })
        .reduce(function (obj, item) {
        obj[item.currency] = item;
        return obj;
    }, {});
    var currencyNames = currencyCodes
        .map(function (v) {
        return { style: "currency", currency: v, currencyDisplay: "name" };
    })
        .reduce(function (obj, item) {
        obj[item.currency + "_name"] = item;
        return obj;
    }, {});
    return {
        number: __assign(__assign({ currency: {
                style: "currency",
                currency: defaultCurrency,
            }, currency_name: {
                style: "currency",
                currency: defaultCurrency,
                currencyDisplay: "name",
            } }, currencySymbols), currencyNames),
    };
}
/**
 * @param defaultTimezone User Time zone names from: https://twiki.org/cgi-bin/xtra/tzdatepick.html
 */
function getDateTimeFormats(defaultTimezone) {
    var utcTimeZone = { hourCycle: "h23", timeZone: "UTC" };
    var userTimeZone = { timeZone: defaultTimezone };
    var shortDate = { month: "numeric", day: "numeric", year: "numeric" };
    var mediumDate = { month: "short", day: "numeric", year: "numeric" };
    var fullDate = { weekday: "short", month: "short", day: "numeric", year: "numeric" };
    var shortTime = { hour: "numeric", minute: "numeric", timeZoneName: "short" };
    var fullTime = { hour: "numeric", minute: "numeric", second: "numeric", timeZoneName: "short" };
    return {
        time: {
            short: __assign(__assign({}, shortTime), utcTimeZone),
            short_user: __assign(__assign({}, shortTime), userTimeZone),
            medium: __assign(__assign({}, shortTime), utcTimeZone),
            medium_user: __assign(__assign({}, shortTime), userTimeZone),
            long: __assign(__assign({}, fullTime), utcTimeZone),
            long_user: __assign(__assign({}, fullTime), userTimeZone),
            full: __assign(__assign({}, fullTime), utcTimeZone),
            full_user: __assign(__assign({}, fullTime), userTimeZone),
        },
        date: {
            short: __assign(__assign({}, shortDate), utcTimeZone),
            short_user: __assign(__assign({}, shortDate), userTimeZone),
            medium: __assign(__assign({}, mediumDate), utcTimeZone),
            medium_user: __assign(__assign({}, mediumDate), userTimeZone),
            long: __assign(__assign({}, mediumDate), utcTimeZone),
            long_user: __assign(__assign({}, mediumDate), userTimeZone),
            full: __assign(__assign({}, fullDate), utcTimeZone),
            full_user: __assign(__assign({}, fullDate), userTimeZone),
            fullDateTime: __assign(__assign(__assign({}, fullDate), fullTime), utcTimeZone),
            fullDateTime_user: __assign(__assign(__assign({}, fullDate), fullTime), userTimeZone),
            longDateTime: __assign(__assign(__assign({}, mediumDate), fullTime), utcTimeZone),
            longDateTime_user: __assign(__assign(__assign({}, mediumDate), fullTime), userTimeZone),
            mediumDateTime: __assign(__assign(__assign({}, mediumDate), shortTime), utcTimeZone),
            mediumDateTime_user: __assign(__assign(__assign({}, mediumDate), shortTime), userTimeZone),
            shortDateTime: __assign(__assign(__assign({}, shortDate), shortTime), utcTimeZone),
            shortDateTime_user: __assign(__assign(__assign({}, shortDate), shortTime), userTimeZone),
        },
    };
}
//# sourceMappingURL=LoomI18n.js.map